import type { Customisations } from '@lorikeetai/web-sdk/types'
import { ButtonIcon, cn } from '@optechai/design-system'
import { MessageCirclePlusIcon, XIcon } from 'lucide-react'

export function ChatHeader({
  customisations,
  onClose,
  onNewChat,
}: {
  customisations: Customisations
  onClose: () => void
  onNewChat: () => void
}) {
  return (
    <div className="p-m bg-surface-accent flex w-full items-center justify-between">
      <h1
        className={cn(
          'font-heading-h2',
          'text-nowrap',
          'overflow-hidden',
          'text-ellipsis',
          customisations.theme?.brandAccentColor && 'text-inverse',
        )}
      >
        {customisations.title || 'Lorikeet AI Agent'}
      </h1>
      <div className="flex">
        <ButtonIcon
          className={cn(
            customisations.theme?.brandAccentColor &&
              'hover:bg-accent-neutral/20 text-inverse',
          )}
          icon={MessageCirclePlusIcon}
          label="Start new chat"
          onClick={onNewChat}
          size="large"
          type="button"
        />
        <ButtonIcon
          className={cn(
            customisations.theme?.brandAccentColor &&
              'hover:bg-accent-neutral/20 text-inverse',
          )}
          icon={XIcon}
          label="Close"
          onClick={onClose}
          size="large"
          type="button"
        />
      </div>
    </div>
  )
}
